/**
 * Zwei Custom Elements für „Zuletzt angesehen" (AP-80): <hy-recently-
 * viewed-tracker> merkt den aktuellen Produkt-Handle in localStorage
 * (sections/hy-main-product.liquid), <hy-recently-viewed> löst die
 * gemerkten Handles gegen einen serverseitig vorgerenderten Kandidatenpool
 * auf (sections/hy-recently-viewed.liquid). Reine Komfortfunktion (CLAUDE.md
 * Regel 7): jeder localStorage-Zugriff steht in try/catch, ein Fehler
 * (deaktiviert/voll) darf nichts anderes stören — die Sektion bleibt dann
 * einfach unsichtbar, kein Fehler, kein leerer Kasten.
 *
 * Warum ein Kandidatenpool statt eines gezielten Server-Abrufs: Liquids
 * request-Objekt liest keine beliebigen URL-Query-Parameter (nur
 * design_mode/host/locale/origin/page_type/path, gegen shopify.dev
 * verifiziert) — eine Sektion kann die in localStorage gespeicherten
 * Handles also nicht per ?handles=… entgegennehmen. Stattdessen rendert
 * die Sektion serverseitig einen begrenzten Pool an Kandidatenkarten
 * (Geldformat/Übersetzung bereits fertig — CLAUDE.md: „Geldformatierung
 * gehören nicht ins JavaScript"), dieses Modul zeigt nur die Karten, deren
 * Handle tatsächlich in localStorage steht — reine DOM-Sichtbarkeit, keine
 * Datenabfrage, kein Money-Handling im JS. Bekannte, akzeptierte Grenze:
 * ein Produkt außerhalb des Kandidatenpools erscheint nicht, selbst wenn es
 * tatsächlich zuletzt angesehen wurde (siehe Sektionskommentar).
 */
const STORAGE_KEY = 'hy_recently_viewed';
const MAX_STORED = 12;
const MAX_DISPLAYED_DEFAULT = 4;

function readHandles() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((handle) => typeof handle === 'string') : [];
  } catch {
    return [];
  }
}

class HyRecentlyViewedTracker extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    if (!handle) return;

    try {
      const handles = readHandles().filter((h) => h !== handle);
      handles.unshift(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch {
      // Regel 7: reine Komfortfunktion, ein Speicherfehler darf sonst
      // nichts stören (z. B. deaktiviertes oder volles localStorage).
    }
  }
}

class HyRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const handles = readHandles();
    if (handles.length === 0) {
      this.remove();
      return;
    }

    const pool = new Map();
    // Nur die Kandidatenkarten — nicht ein verschachteltes [data-handle]
    // (z. B. <hy-wishlist-toggle> nutzt data-wishlist-handle, M8; der enge
    // Selektor ist die robustere Absicherung).
    for (const item of this.querySelectorAll('.hy-recently-viewed__item')) {
      pool.set(item.dataset.handle, item);
    }

    const maxDisplayed = Number(this.dataset.maxDisplayed) || MAX_DISPLAYED_DEFAULT;
    // On a product page the product itself is not "recently viewed" — it is
    // the page (data-exclude-handle, sections/hy-recently-viewed.liquid).
    const exclude = this.dataset.excludeHandle;
    const matched = [];
    for (const handle of handles) {
      if (handle === exclude) continue;
      const item = pool.get(handle);
      if (!item) continue;
      matched.push(item);
      if (matched.length >= maxDisplayed) break;
    }

    if (matched.length === 0) {
      this.remove();
      return;
    }

    const list = this.querySelector('[data-hy-recently-viewed-list]');
    matched.forEach((item) => item.removeAttribute('hidden'));
    // Ordnet zugleich neu (Reihenfolge aus localStorage, neuestes zuerst)
    // und entfernt die nicht getroffenen Kandidaten aus dem DOM.
    list.replaceChildren(...matched);
    this.removeAttribute('hidden');
  }
}

customElements.define('hy-recently-viewed-tracker', HyRecentlyViewedTracker);
customElements.define('hy-recently-viewed', HyRecentlyViewed);
